import React, { ReactNode } from "react";
import classNames from "classnames";
import type { FieldConfig, FieldInputProps } from "formik";
import formStyles from "../../features/MainForm/Form.module.css";
import styles from "./Checkbox.module.css";

interface CheckboxProps {
  id: string;
  name: string;
  variant?: "default" | "outlined" | "filled";
  getFieldProps: (
    nameOrOptions: string | FieldConfig<any>
  ) => FieldInputProps<any>;
  touched?: { [key: string]: boolean | boolean[] };
  errors?: { [key: string]: string | string[] };
  children: ReactNode;
}

export const CheckboxField: React.FC<CheckboxProps> = ({
  id,
  name,
  variant = "default",
  getFieldProps,
  touched,
  errors,
  children,
}) => {
  const formikProps = getFieldProps(name);

  const checkboxClass = classNames(styles.checkboxField, {
    "checkbox-field--outlined": variant === "outlined",
    "checkbox-field--filled": variant === "filled",
  });

  return (
    <div className={formStyles.formGroup}>
      <div className={checkboxClass}>
        <input
          id={id}
          type="checkbox"
          {...formikProps}
          className={classNames({
            [styles.checkboxInput]: touched?.[name] && errors?.[name],
          })}
        />
        <label htmlFor={id}>{children}</label>
      </div>
      {touched?.[name] && errors?.[name] && (
        <p className={formStyles.formError}>{errors[name]}</p>
      )}
    </div>
  );
};
